import styled from 'styled-components';
import {V6} from '../../theme';
import {Badge} from './Badge';

export const CampaignSaleBadge = styled(Badge)<{backgroundColor?: string}>`
  color: ${V6.badges.colors.sale};
  background-color: ${({backgroundColor}) =>
    backgroundColor || V6.badges.backgroundColors.campaign};
`;
